import Text from "ab-text";

import "./ab-terruno.scss";

const Terruno = ({ title, body, righttitle, list }) => {
  return (
    <div className="ab-terruno">
      <div>
        <Text element="h2">{title}</Text>
        <Text>{body}</Text>
      </div>
      <div>
        <Text element="h2">{righttitle}</Text>
        <p>
          <ul>
            {list?.map((itm) => (
              <li>{itm.item}</li>
            ))}
          </ul>
        </p>
      </div>
    </div>
  );
};

export default Terruno;
